//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';


export interface ParamsType {
    customer_id: number;
}


const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /api-proxy/staff/freebet/credits/{customer_id} -> get -> ${code}`);
    };
};

export const Response200IO = t.interface({
    bonusCredits: t.array(t.interface({
        amount: t.number,
        createdAt: t.string,
        enabled: t.boolean,
        expiryDate: t.string,
        history: t.array(t.interface({
            changeBody: t.interface({
                amountDelta: t.union([t.null, t.undefined, t.number]),
                enabled: t.union([t.null, t.undefined, t.boolean]),
                expiryDate: t.union([t.null, t.undefined, t.string]),
                minimalOds: t.union([t.null, t.undefined, t.number]),
            }),
            changedBy: t.union([t.null, t.undefined, t.interface({
                id: t.number,
                name: t.string,
                type: t.string,
            })]),
            date: t.string,
            newCreditAmount: t.union([t.null, t.undefined, t.number]),
            newWalletAmount: t.union([t.null, t.undefined, t.number]),
            reason: t.union([t.null, t.undefined, t.string]),
            type: t.string,
        })),
        id: t.number,
        isUnique: t.boolean,
        minimalOdds: t.union([t.null, t.undefined, t.number]),
        promotionId: t.string,
        updatedAt: t.union([t.null, t.undefined, t.string]),
        walletId: t.number,
    })),
    bonusWallet: t.interface({
        accountId: t.number,
        code: t.string,
        createdAt: t.string,
        id: t.number,
        universe: t.string,
    }),
    totalAmount: t.number,
});
export type Response200Type = {
    bonusCredits: Array<{
        amount: number;
        createdAt: string;
        enabled: boolean;
        expiryDate: string;
        history: Array<{
            changeBody: {
                amountDelta?: null | undefined | number;
                enabled?: null | undefined | boolean;
                expiryDate?: null | undefined | string;
                minimalOds?: null | undefined | number;
            };
            changedBy?: null | undefined | {
                id: number;
                name: string;
                type: string;
            };
            date: string;
            newCreditAmount?: null | undefined | number;
            newWalletAmount?: null | undefined | number;
            reason?: null | undefined | string;
            type: string;
        }>;
        id: number;
        isUnique: boolean;
        minimalOdds?: null | undefined | number;
        promotionId: string;
        updatedAt?: null | undefined | string;
        walletId: number;
    }>;
    bonusWallet: {
        accountId: number;
        code: string;
        createdAt: string;
        id: number;
        universe: string;
    };
    totalAmount: number;
};
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response400IO = t.string;
export type Response400Type = string;
export const decodeResponse400 = createGuard(400, Response400IO);

export const Response401IO = t.string;
export type Response401Type = string;
export const decodeResponse401 = createGuard(401, Response401IO);

export const Response500IO = t.string;
export type Response500Type = string;
export const decodeResponse500 = createGuard(500, Response500IO);



type ExtraHeadersType = Record<string, string>


/**
 * @deprecated - Please use this method "openapiProxyStaffFreebetCreditsRequest"
 */
export const openapi_proxy_staff_freebet_credits = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<FetchGeneralRawResponseType> => {
    
        
    const query = '';
    const url = `${api_url}/api-proxy/staff/freebet/credits/${params.customer_id}${query}`;
    
    const method = 'GET';
    const paramsFetch = {
        url,
        body: undefined,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiProxyStaffFreebetCreditsParamsType = ParamsType;

export type OpenapiProxyStaffFreebetCreditsResponseType = {
    status: 200;
    body: Response200Type;
} | {
    status: 400;
    body: Response400Type;
} | {
    status: 401;
    body: Response401Type;
} | {
    status: 500;
    body: Response500Type;
};

export type OpenapiProxyStaffFreebetCreditsResponse200Type = Response200Type;

export const openapiProxyStaffFreebetCreditsRequest = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<OpenapiProxyStaffFreebetCreditsResponseType> => {
    const response = await openapi_proxy_staff_freebet_credits(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }
    
    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 400) {
        return { status: 400, body: decodeResponse400(json) };
    }

    if (status === 401) {
        return { status: 401, body: decodeResponse401(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiProxyStaffFreebetCreditsRequest - unhandled response ${response.status}`);
};

